import { render, staticRenderFns } from "./Trainers.vue?vue&type=template&id=0d1decfe&scoped=true&"
import script from "./Trainers.vue?vue&type=script&lang=js&"
export * from "./Trainers.vue?vue&type=script&lang=js&"
import style0 from "./Trainers.vue?vue&type=style&index=0&id=0d1decfe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1decfe",
  null
  
)

export default component.exports